import { IconForward } from '@mv/icons/web';
import { Button, Container } from '@mv/web-ui';
import NextLink from 'next/link';
import styles from './ErrorPage.module.scss';

type Props = {
	title: string;
	description: string;
	label: string;
};

function ErrorPage({ title, description, label }: Props) {
	return (
		<Container>
			<div className={styles.container}>
				<h1 className={styles.title}>{title}</h1>
				<p className={styles.description}>{description}</p>
				<Button asChild size="lg">
					<NextLink href="/">
						{label} <IconForward />
					</NextLink>
				</Button>
			</div>
		</Container>
	);
}

export default ErrorPage;
